export const TAM = 'TAM';
export const FAM = 'FAM';
export const CAM = 'CAM';
export const USER = 'USER';
export const GUEST = 'GUEST';
